import type SearchScenarioId from 'owa-search-store/lib/store/schema/SearchScenarioId';
import { createStore } from 'owa-satcheljs';
import type { default as RefinersState, SearchRefinersState } from './schema/SearchRefinersState';

export const createDefaultRefinersStore = (): SearchRefinersState => {
    return {
        appliedRefiners: [],
        suggestedRefiners: [],
        refinersInstrumentationContext: undefined,
    };
};

const refinersState: RefinersState = {
    refiners: new Map<SearchScenarioId, SearchRefinersState>([]),
};

export const getSearchRefinersStore: () => RefinersState = createStore<RefinersState>(
    'searchRefinersStore',
    refinersState
);
